export default __webpack_public_path__ + "static/media/Icon-ionic-ios-body.c64b4926.svg";